import { useSyncExternalStore } from 'react';
import { lsGet, lsSet } from './storage';

/* Выбранный на главной день — тренировка открывается на нём. Живёт в памяти:
   после перезапуска главная снова открывается на «сегодня». */
let sel: string | null = null;
const subs = new Set<() => void>();
export const setSelDate = (d: string | null) => {
  sel = d;
  subs.forEach((f) => f());
};
export function useSelDate(today: string) {
  const v = useSyncExternalStore(
    (f) => {
      subs.add(f);
      return () => subs.delete(f);
    },
    () => sel,
  );
  return v || today;
}

/* CLI-6. Возврат в приложение: шла тренировка — открываем её, пока не кончился
   день; иначе меньше 30 минут — тот же экран, больше — главная. Время ухода
   в фон и открытый экран — на устройстве. */
const RESUME_MS = 30 * 60_000;
interface Last {
  path: string;
  at: number;
}
export const rememberPath = (path: string) => lsSet<Last>('last', { path, at: Date.now() });
export const touchLast = () => {
  const l = lsGet<Last | null>('last', null);
  if (l) lsSet<Last>('last', { ...l, at: Date.now() });
};
/** Тренировка начата (открыта сегодняшняя) — до завершения или конца дня */
export const setActive = (date: string | null) => lsSet('active', date ?? undefined);

export function resumeTarget(today: string): string | null {
  const active = lsGet<string | null>('active', null);
  if (active && active === today) return '/day/' + active;
  if (active && active !== today) setActive(null);
  const l = lsGet<Last | null>('last', null);
  if (!l) return null;
  return Date.now() - l.at < RESUME_MS ? l.path : '/';
}
